var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import styled from '@emotion/styled';
import { space, color, display, themeGet, fontSize, lineHeight, letterSpacing, } from 'styled-system';
import { textDecoration } from '../../common/theme/system-utilities';
var BaseText = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n"])), fontSize, lineHeight, letterSpacing);
BaseText.defaultProps = {
    fontSize: 'fs_11',
    lineHeight: 'lh_16',
    letterSpacing: '1px',
};
var UspBarRichText = styled(BaseText)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n\n  p {\n    ", ";\n\n    margin: ", ";\n  }\n\n  a {\n    ", ";\n    ", ";\n\n    &:hover {\n      color: ", ";\n    }\n  }\n"], ["\n  ", ";\n\n  p {\n    ", ";\n\n    margin: ", ";\n  }\n\n  a {\n    ", ";\n    ", ";\n\n    &:hover {\n      color: ", ";\n    }\n  }\n"])), space, color, themeGet('space.sp_0'), textDecoration, color, themeGet('colors.brand.normal'));
UspBarRichText.defaultProps = __assign(__assign({}, BaseText.defaultProps), { mx: 'sp_0', my: ['sp_4', null, 'sp_8'], textDecoration: 'underline' });
var UspBarPlainText = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), space);
UspBarPlainText.defaultProps = {
    mx: 'sp_0',
    my: ['sp_4', null, 'sp_8'],
};
var Link = styled(BaseText)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", ";\n\n  &:hover {\n    color: ", ";\n  }\n"], ["\n  ", "\n  ", "\n  ", ";\n\n  &:hover {\n    color: ", ";\n  }\n"])), color, display, textDecoration, themeGet('colors.brand.normal'));
Link.defaultProps = __assign(__assign({}, BaseText.defaultProps), { as: 'a', display: 'block', textDecoration: 'underline' });
var Text = styled(BaseText)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n  ", "\n"], ["\n  ", ";\n  ", "\n"])), space, color);
Text.defaultProps = __assign(__assign({}, BaseText.defaultProps), { as: 'p', m: 'sp_0' });
export { UspBarRichText, UspBarPlainText, Link, Text };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
